module.exports = __webpack_public_path__ + "img/imagenClipper.85c2e8a7.svg";